/**
 * Parses a string or number value and returns the parsed number.
 * If the value is not a string, it is returned as is.
 * If the value is a string, it is parsed and multiplied by the corresponding multiplier based on the suffix.
 * If no suffix is found, the string is parsed as a float.
 * @param value - The value to parse.
 * @returns The parsed number.
 */
export function parseNumber(value: string) {
    if (typeof value !== 'string') {
        return value;
    }

    const match = value.replace(',', '').match(/([\d\.]+)(\w)/);

    if (match) {
        const multiplier = {
            E: 1e18,
            P: 1e15,
            T: 1e12,
            G: 1e9,
            M: 1e6,
            k: 1e3,
            m: 1e-3,
            u: 1e-6,
            n: 1e-9,
            p: 1e-12,
            f: 1e-15
        };

        const ml = multiplier[match[2]] || 1;
        return parseFloat(value) * ml;
    }

    return parseFloat(value);
}
